module.exports = __webpack_public_path__ + "img/home.2586976c.png";